import { createBrowserHistory } from 'history';

const routeHistory = createBrowserHistory();

export const goTo = (path: string): void => routeHistory.replace(path);

export default routeHistory;
